import axios from "../axiosInstance"

export interface TeamsChannel {
  id: number
  teamId: string
  teamName: string
  channelId: string
  channelName: string
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export interface AvailableChannel {
  teamId: string
  teamName: string
  channelId: string
  channelName: string
}

export const getTeamsChannels = async (): Promise<TeamsChannel[]> => {
  const res = await axios.get("/teams/channels")
  return res.data
}

export const browseTeamsChannels = async (): Promise<AvailableChannel[]> => {
  const res = await axios.get("/teams/channels/browse")
  return res.data
}

export const addTeamsChannel = async (channel: AvailableChannel): Promise<TeamsChannel> => {
  const res = await axios.post("/teams/channels", channel)
  return res.data
}

export const removeTeamsChannel = async (id: number): Promise<void> => {
  await axios.delete(`/teams/channels/${id}`)
}

export const toggleTeamsChannel = async (id: number, enabled: boolean): Promise<TeamsChannel> => {
  const res = await axios.put(`/teams/channels/${id}/toggle`, { enabled })
  return res.data
}
